<ng-template #contentAlertBien let-modal class="modal-share p-3">
    <div class="modal-header container border-0 pt-3">

        <button type="button" class="btn-close btn-close-black me-1" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body  p-0">
        <div class="text-center mb-5">
            <img width="61" height="60" class="my-3"  src="../../../../../assets/resources/web/images/design/ok.png">
            <h4 class="fw-bolder">{{message}}</h4>
            <div class="my-3" role="button" (click)="modal.dismiss('Cross click')">
                <button class="btn btn-outline-primary">
                    Retour<i style="color: #00579C;" class="bi bi-arrow-right mx-2  h4"></i></button>
            </div>
        </div>
    </div>
</ng-template>
